import { defineStore } from 'pinia';

export const useSidebar = defineStore('sidebar', {
  state: () => {
    return {
      isOpenSidebar: false,
    };
  },
});
